import React, { createContext, useState } from 'react';
import { toast } from 'react-toastify';
import axios from 'axios';

import api from '../Services/api';
import { ErrorList, Response } from '../models/responseType';
import { ResponseLogin, User } from '../models/userType';
import { RoleEnum } from '../models/enumType';

interface AuthContextData {
    signed: boolean;
    user: User | null,
    login(email: string, password: string): Promise<ErrorList[]>;
    logout(): void;
    hasRole(role: string): boolean;
}

const AuthContext = createContext<AuthContextData>({} as AuthContextData);

interface Props {
    children: React.ReactNode;
}

export const AuthProvider: React.FC<Props> = ({ children }) => {

    const [user, setUser] = useState<User | null>(
        sessionStorage.getItem("@App:user") ?
            JSON.parse(sessionStorage.getItem("@App:user") as string) : null
    );

    const login = async (email: string, password: string): Promise<ErrorList[]> => {
        try {
            debugger;
            const response = await api.post(`account/login`, {
                email: email,
                password: password,
            });
            const result: Response<ResponseLogin> = response.data;
            debugger;
            if (result.isSuccess) {
                setUser(result.data.user);
                api.defaults.headers.common['Authorization'] = `Bearer ${result.data.token}`;
                sessionStorage.setItem("@App:token", result.data.token);
                sessionStorage.setItem("@App:user", JSON.stringify(result.data.user));
                window.location.href = '/events';
                return [];
            }
            return showLoginErrors(result);
        } catch (error) {
            if (axios.isAxiosError(error) && error.response) {
                return showLoginErrors(error.response.data as Response<ResponseLogin> | undefined);
            }
            toast.error('Não foi possível conectar ao servidor. Tente novamente.');
            return [];
        }
    }

    const showLoginErrors = (result?: Partial<Response<ResponseLogin>>): ErrorList[] => {
        const errors = result?.errorList ?? [];
        toast.warn(errors[0]?.errorMessage || result?.message || 'Não foi possível realizar o login.');
        return errors;
    }

    const logout = () => {
        setUser(null);
        sessionStorage.removeItem("@App:token");
        sessionStorage.removeItem("@App:user");
        window.location.href = '/login';
    }

    const hasRole = (currentRole: RoleEnum): boolean => {
        
        if (user) {
            return user.roles.find(role => role === currentRole) ? true : false;
        }
        return false;
    }

    return (
        <AuthContext.Provider value={{
            signed: Boolean(user),
            login,
            user,
            logout,
            hasRole
        }}>
            {children}
        </AuthContext.Provider>
    );
};

export default AuthContext;